import { BoxProps, FlexProps } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

export const tabStyles: BoxProps = {
  fontSize: 'secondaryNavBarHeader',
  color: customTheme.colors.secondaryNavBarItem,
  _hover: {
    color: customTheme.colors.gray['900'],
  },
  h: 'full',
  mr: '5',
  px: '2',
};

export const selectedTabStyles: BoxProps = {
  color: 'primary',
  borderRadius: 6,
  bg: colorOpacity(customTheme.colors.primary, 0.1),
};

export const wrapperStyle: FlexProps = {
  height: 'secondaryNavBarHeight',
  bg: 'gray.0', //'secondaryNavBarBg',
  boxShadow: `inset 0 1px 0 0${customTheme.colors.primary}, 0 0 1px #aaa`,
  h: 'full',
};
